export const DagazMark = ({ className = "w-8 h-8", stroke = "currentColor" }) => (
    <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
        <path d="M24 5 L45 43" stroke={stroke} strokeWidth="3" strokeLinecap="square" />
        <path d="M24 5 L3 43" stroke={stroke} strokeWidth="3" strokeLinecap="square" />
        <path d="M16.5 31 L6.5 40.5" stroke="#D4AF37" strokeWidth="2.4" strokeLinecap="square" />
        <path d="M18.7 26.4 L8 33.2" stroke="#D4AF37" strokeWidth="2.4" strokeLinecap="square" />
        <path d="M20.8 21.8 L9.8 26" stroke="#D4AF37" strokeWidth="2.4" strokeLinecap="square" />
    </svg>
);

export const LogoLockup = ({ dark = false }) => (
    <span className="flex items-center gap-3" data-testid="logo-lockup">
        <DagazMark className={`w-7 h-7 ${dark ? "text-chalk" : "text-graphite"}`} />
        <span className="leading-none">
            <span className={`block font-sans text-[15px] font-semibold tracking-[0.35em] ${dark ? "text-chalk" : "text-graphite"}`}>
                DAGAZ
            </span>
            <span className={`block font-sans text-[8px] tracking-[0.42em] mt-1 ${dark ? "text-fog" : "text-slate"}`}>
                DEVELOPMENT
            </span>
        </span>
    </span>
);
